import React, { useState } from 'react';

const API = '/api/auth';

// Eye icons as inline SVG (no emoji)
const EyeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const EyeOffIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${API}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error); setLoading(false); return; }
      localStorage.setItem('crm_token', data.token);
      localStorage.setItem('crm_user', JSON.stringify(data.user));
      onLogin(data.user, data.token);
    } catch {
      setError('Server nicht erreichbar');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card-header">
          <img src="/logo.png" alt="Futuris Sales" className="login-logo" />
          <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, fontWeight: 500, marginTop: 8, letterSpacing: '0.03em' }}>Vertriebspartner-Portal</p>
        </div>
        <div className="login-card-body">
          <h2>Anmelden</h2>
          <form onSubmit={handleSubmit} noValidate>
            <div className="form-field">
              <label htmlFor="login-username">Benutzername</label>
              <input
                id="login-username"
                autoFocus
                autoComplete="username"
                autoCapitalize="none"
                autoCorrect="off"
                value={username}
                onChange={e => setUsername(e.target.value)}
                placeholder="Benutzername"
                required
              />
            </div>
            <div className="form-field" style={{ marginTop: 12, position: 'relative' }}>
              <label htmlFor="login-password">Passwort</label>
              <input
                id="login-password"
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Passwort"
                required
                style={{ paddingRight: 44 }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(v => !v)}
                aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
                style={{
                  position: 'absolute', right: 2, bottom: 0,
                  width: 40, height: 40,
                  background: 'none', border: 'none', cursor: 'pointer',
                  color: '#6b7280', display: 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  borderRadius: 6, transition: 'color 0.15s',
                  touchAction: 'manipulation',
                }}
                onMouseEnter={e => e.currentTarget.style.color = '#6366f1'}
                onMouseLeave={e => e.currentTarget.style.color = '#6b7280'}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
            {error && (
              <div className="login-error" role="alert" aria-live="polite">
                {error}
              </div>
            )}
            <button
              type="submit"
              className={`btn btn-gradient${loading ? ' btn-loading' : ''}`}
              style={{ width: '100%', marginTop: 20 }}
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? 'Anmelden...' : 'Anmelden'}
            </button>
          </form>
        </div>
      </div>
      <p style={{ position: 'fixed', bottom: 20, left: 0, right: 0, textAlign: 'center', fontSize: 12, color: '#6b7280' }}>
        Erstellt von B.Sc. Edon Hajdini ·{' '}
        <a href="https://www.linkedin.com/in/edon-hajdini-b38106291/" target="_blank" rel="noreferrer" style={{ color: '#6366f1', textDecoration: 'none' }}>
          LinkedIn
        </a>
      </p>
    </div>
  );
}
